<div class="card av-wrap">

  <!-- ── Cabecera ── -->
  <div class="card-header card-chart card-header-danger d-flex justify-content-between align-items-center">
    <div>
      <h5 class="card-title mb-0 mt-3"><strong>Seguimiento</strong></h5>
      <h4 class="card-category mb-0" *ngIf="titulo">
        {{ titulo }} <span *ngIf="idProyecto">· {{ idProyecto }}</span>
      </h4>
    </div>
    <button mat-icon-button (click)="close()" aria-label="Cerrar">
      <mat-icon>clear</mat-icon>
    </button>
  </div>

  <div class="card-body px-4 pb-0">

    <!-- ── Info bar ── -->
    <div class="d-flex align-items-start px-3 py-2 bg-light border-bottom seg-info-bar">
      <div class="d-flex flex-column">
        <span class="av-lbl">Servicio</span>
        <span class="small text-secondary">
          {{ aplicacion }} <span class="badge badge-pill seg-badge-purple align-self-start">{{ categoria }}</span>
        </span>
      </div>
      <div class="d-flex flex-column" *ngIf="cliente">
        <span class="av-lbl">Cliente</span>
        <span class="small text-secondary">{{ cliente }}</span>
      </div>
      <div class="d-flex flex-column ml-auto">
        <span class="av-lbl">Inicio</span>
        <span class="small text-secondary">{{ fechaInicio }}</span>
      </div>
      <div class="d-flex flex-column">
        <span class="av-lbl">Fin</span>
        <span class="small text-secondary">{{ fechaFin }}</span>
      </div>
    </div>

    <!-- ── Horas del servicio ── -->
    <div class="px-0 py-2 border-bottom">
      <div class="row no-gutters">
        <div class="col-6 col-sm-3 seg-hrs-col">
          <div class="card seg-stat-card p-2 d-flex flex-row align-items-center">
            <span class="seg-stat-icon seg-stat-icon--blue"><mat-icon>schedule</mat-icon></span>
            <div class="min-width-0">
              <span class="av-lbl">Contratadas</span>
              <div class="seg-stat-value">{{ horasContratadas }} hrs</div>
            </div>
          </div>
        </div>
        <div class="col-6 col-sm-3 seg-hrs-col">
          <div class="card seg-stat-card p-2 d-flex flex-row align-items-center">
            <span class="seg-stat-icon seg-stat-icon--orange"><mat-icon>bar_chart</mat-icon></span>
            <div class="min-width-0">
              <span class="av-lbl">Utilizadas</span>
              <div class="seg-stat-value seg-text-orange">{{ horasUsadas }} hrs</div>
            </div>
          </div>
        </div>
        <div class="col-6 col-sm-3 seg-hrs-col">
          <div class="card seg-stat-card p-2 d-flex flex-row align-items-center">
            <span class="seg-stat-icon seg-stat-icon--green"><mat-icon>hourglass_bottom</mat-icon></span>
            <div class="min-width-0">
              <span class="av-lbl">Disponibles</span>
              <div class="seg-stat-value seg-text-green">{{ saldoLabel }}</div>
            </div>
          </div>
        </div>
        <div class="col-6 col-sm-3 seg-hrs-col">
          <div class="card seg-stat-card p-2 d-flex flex-row align-items-center">
            <span class="seg-stat-icon seg-stat-icon--gray"><mat-icon>task_alt</mat-icon></span>
            <div class="min-width-0">
              <span class="av-lbl">Cos (tareas)</span>
              <div class="seg-stat-value text-muted">{{ horasUsadasCalculadas }} hrs</div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-muted seg-cos-note" *ngIf="diferenciaCos > 0">
        *Las hrs registradas en tareas (COS) difieren {{ diferenciaCos }} hrs del seguimiento
      </div>
    </div>

    <!-- ── Formulario ── -->
    <div class="px-3 pt-3">

      <div class="mb-3">
        <span class="av-lbl mb-2">Nuevo registro</span>

        <div class="seg-counter-box p-2 mt-1">
          <div class="row align-items-center">
            <div class="col-12 col-sm-6">
              <span class="av-lbl av-lbl--wrap">Hrs a registrar <span class="small text-muted"> (en este seguimiento)</span></span>
              <div class="d-flex align-items-center seg-counter-controls mt-1">
                <button
                  type="button"
                  class="btn btn-outline-secondary  seg-counter-btn"
                  (click)="decrementar()"
                  [disabled]="horasAdicionales <= 0"
                >
                  &minus;
                </button>
                <input
                  type="number"
                  min="0"
                  class="form-control form-control-sm text-center seg-counter-input"
                  [(ngModel)]="horasAdicionales"
                  aria-label="Hrs a registrar (en este seguimiento)"
                />
                <button type="button" class="btn btn-outline-secondary  seg-counter-btn" (click)="incrementar()">
                  +
                </button>
                <span class="small">hrs adicionales</span>
              </div>
            </div>
            <div class="col-12 col-sm-6 text-sm-right mt-3 mt-sm-0">
              <span class="av-lbl av-lbl--wrap">Hrs disponibles <span class="small text-muted"> (Tras el registro)</span> </span>
              <div class="seg-stat-value seg-text-green">{{ disponiblesTrasRegistrarLabel }}</div>
              <div class="small ">Utilizadas {{ utilizadasTrasRegistrar }} hrs</div>
            </div>
          </div>
        </div>
      </div>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Comentario <span style="color:#e53935">*</span></mat-label>
        <textarea
          matInput
          [(ngModel)]="observaciones"
          name="observaciones"
          rows="3"
          maxlength="500"
          placeholder="Nuevo comentario de seguimiento..."
          aria-label="Comentario *"
        ></textarea>
        <mat-hint align="end">{{ observaciones.length }}/500</mat-hint>
      </mat-form-field>

    </div>

    <!-- ── Historial de comentarios ── -->
    <div class="av-historial px-3 pb-3" *ngIf="!isLoading && !loadError && comentarios.length > 0">
      <span class="av-lbl mb-2">Historial de seguimientos</span>
      <div class="av-historial-list">
        <div *ngFor="let comentario of comentarios; let i = index" class="av-historial-item">
          <div class="d-flex align-items-center flex-wrap seg-hist-meta">
            <span class="av-hist-fecha text-muted">{{ comentario.fecha }}</span>
            <span class="badge badge-pill seg-badge-purple" *ngIf="comentario.horasAgregadas">
              +{{ comentario.horasAgregadas }} hrs
            </span>
            <span class="badge badge-pill seg-badge-actual" *ngIf="i === 0">ACTUAL</span>
            <span class="av-hist-user text-muted ml-auto">
              <img class="av-hist-user-icon rounded-circle" src="assets/img/faces/profile.png" alt="" />{{ comentario.nombreUsuario }}
            </span>
          </div>
          <p class="av-hist-desc seg-hist-desc">{{ comentario.descripcion }}</p>
          <p class="seg-hist-summary mb-0" *ngIf="comentario.horasAgregadas">
            <span class="seg-text-orange">{{ comentario.horasAcumuladasTrasRegistro }} HRS ACUMULADAS</span> ·
            <span class="seg-text-green">SALDO {{ saldoHistorialLabel(comentario) }}</span>
          </p>
        </div>
      </div>
    </div>

    <div class="text-center text-muted py-3" *ngIf="isLoading">Cargando historial...</div>
    <div class="text-center text-muted py-3" *ngIf="!isLoading && loadError">
      No se pudo cargar el historial de seguimiento.
    </div>
    <div class="text-center text-muted py-3" *ngIf="!isLoading && !loadError && comentarios.length === 0">
      Aún no hay seguimientos registrados para este servicio.
    </div>

    <!-- ── Acciones ── -->
    <div class="av-actions-bar d-flex justify-content-end align-items-center seg-actions-row px-3 pt-1 pb-3 border-top">
      <button mat-raised-button class="btn" (click)="close()">
        <mat-icon>clear</mat-icon> Cerrar
      </button>
      <button mat-raised-button class="btn btn-primary" (click)="guardar()" [disabled]="!puedeRegistrar">
        <mat-icon>check</mat-icon>
        {{ isSaving ? "Guardando ..." : "Guardar" }}
      </button>
    </div>

  </div><!-- /card-body -->
</div><!-- /card -->
